<script>
    import {
        Alert,
        Button,
        InputText,
        Row,
        Typography,
        ScrollBox,
        SelectX as Select
    } from '$lib/components/UI'
    import { createEventDispatcher, getContext, onMount } from 'svelte'
    import ModalX from '$lib/components/UI/ModalX.svelte'
    import ItemsStoreForm from './ItemsStoreForm2.svelte'
    import ConfirmationButton from './ConfirmationButton.svelte'
    import { navigate } from 'svelte-navigator'
    import dictionaries from '$lib/stores/dictionaries'
    import { Oferta } from '../../services/interfaces'
    import offers from '$lib/services/collections/offers'
    import tenders from '$lib/services/collections/tenders'
    export let title = 'Ofertar'
    export let subtitle = ''
    export let dataSource = {}
    export let data = {}
    export let valid = false
    export let editMode = false
    export let items
    const toast = getContext('toast')
    let offertItems = structuredClone(dataSource.items)
    const dispatch = createEventDispatcher()
    function onClose() {
        dispatch('close')
    }
    function onSuccess() {
        dispatch('success')
    }
    let sourceCompare
    onMount(() => {
        data.id = dataSource.id
        data.id_sucursal = dataSource.sucursal.id
        data.id_licitacion = dataSource.id_licitacion

        if(editMode){
            sourceCompare = {
                tiempo_entrega:data.tiempo_entrega,
                items:structuredClone(offertItems)
            }
        }
    })
    let isSubmitting = false
    const addOffer = async () => {
        isSubmitting = true
        console.log({ payload: data })
        let promise = Oferta.add(data).then(async res => {
            if (res.ok) {
                data = {}
                isSubmitting = false
                let tmpData = Oferta.convert(await res.json())
                offers.add(tmpData)
            }
        })
        navigate('/home/licitaciones')
        onClose()
        try {
            console.log({dataSource})
            await tenders.collection.put({
                ...dataSource,
                // id: [dataSource?.id_licitacion, dataSource?.cuit_ii, dataSource?.sucursal?.id],
                cuit: dataSource?.cuit_ii,
                nombre_apellido_asegurado: '',
                dni_asegurado: '', preseleccionados: '', 
                ofertas: '',
                observacion_readjudicacion: '',
                state: 'pending'
            }).then(()=> {
                tenders.refresh()
            })
        } catch(e) {console.error(e)}
        toast && toast.promise(promise, {
            loading: 'Enviando oferta...',
            success: 'Oferta enviada correctamente',
            error: 'Error al enviar la oferta',
        }, {
            position: 'top-center',
            duration: 2000
        })
    }

    // En modo edición, utilizo este codigo para chequear si se cambió algun dato, según eso habilito/inhabilito el boton
    $:destinyCompare = {
        tiempo_entrega: data.tiempo_entrega,
        items: data.items,
    }
    let editHasChanges = false;
    $:if(sourceCompare && destinyCompare && editMode){
        let sourceCompareClone = structuredClone(sourceCompare)
        let destinyCompareClone = structuredClone(destinyCompare)
        let equalEntrega = sourceCompare?.tiempo_entrega === destinyCompare?.tiempo_entrega
        let equalItems = true
        destinyCompareClone.items.forEach(item=>{
            item.total = item.total.toString()
            // item.maxItems = item.maxItems.toString()
        })
        sourceCompareClone.items.forEach(item=>{
            item.total = item.total.toString()
            item.maxItems = item.maxItems.toString()
        })
        
        let sortedSourceItems = sourceCompareClone?.items?.sort((a,b)=>{
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;            
        })
        let sortedDestinyItems = destinyCompareClone.items.sort((a,b)=>{
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;            
        })
        sortedDestinyItems?.forEach((item,i) => {
            if(JSON.stringify(item)!==JSON.stringify(sortedSourceItems[i])){
                equalItems = false
            }
        });
        editHasChanges = !equalEntrega || !equalItems
    }
    const updateOffer = async () => {
        console.log('updating oferta:', data)
        let { id, ...rest } = data
        isSubmitting = true
        await Oferta.update(id, rest)
            .then(async (res) => {
                if (res.ok) {
                    isSubmitting = false
                    onClose()
                    toast &&
                        toast.success(
                            'Solicitud de modificación cargada correctamente',
                            // { position: 'bottom-center', duration: 2000 }
                        )
                    onSuccess()
                } else if (res.status !== 500) {
                    isSubmitting = false
                    let msg = await res.text()
                    toast &&
                        toast.error(msg, {
                            // position: 'bottom-center',
                            duration: 2000,
                        })
                } else {
                    isSubmitting = false
                    onClose()
                    throw new Error('Error al actualizar oferta.')
                }
            })
            .catch((err) => {
                isSubmitting = false
                toast &&
                    toast.error(err.message, {
                        // position: 'bottom-center',
                        duration: 2000,
                    })
            })
    }

    const schemaDatatable = {
        categoria: {
            label: 'Categoría',
            render: (v) =>
                $dictionaries?.lic_items_polaris?.find((t) => t.value === v)
                    ?.label || '-',
        },
        producto: {
            render: (v) =>
                $dictionaries?.lic_items_polaris.find((i) => i.value === v)
                    ?.label,
        },
        descripcion: { label: 'Descripción' },
        cantidad: {},
    }
    let editing
    $: data.items = offertItems
    let validTiempoEntrega
    $: valid = validTiempoEntrega && data.items?.length === items.length && data.items.every(i => i.total > 0) && !editing

</script>

<ModalX
    {title}
    {subtitle}
    style="width: auto; min-height: 600px; width: 100%; max-width: calc(100% - 140px); height: calc(100% - 100px);margin: 0 0 0 0"
    on:close={onClose}
>
    <ScrollBox width="100%" height="100%" alwaysVisible={true}>
        <Row>
            <InputText
                label="CUIT Proveedor"
                disabled
                bind:value={dataSource.cuit_ii}
            />
            <InputText
                disabled
                label="Sucursal"
                bind:value={dataSource.sucursal.nombre}
            />
        </Row>
        <Select
            label="Tiempo de entrega"
            bind:value={data.tiempo_entrega}
            bind:valid={validTiempoEntrega}
            validation={v => v !== null}
            errorMsg="Seleccione un tiempo de entrega válido."
            required
            options={$dictionaries.lic_tiempos_de_entrega || []}
        />
        <!--<Typography>Piezas de Licitación {editMode ? 'adjudicadas' : ''}</Typography>
         <Datatable
            schema={schemaDatatable}
            data={editMode
                ? writable(items.filter((item) => item.compra == '1'))
                : writable(items)}
        /> -->
        <Typography>Piezas a ofertar</Typography>
        <ItemsStoreForm edit={editMode} bind:editing bind:value={offertItems} />
        {#if editMode}
            <InputText label="Observaciones" bind:value={data.observaciones} />
        {/if}
        <Alert type="info" style="margin-top: 20px;">
            Los valores cotizados contemplan el costo de la entrega a domicilio.
        </Alert>
    </ScrollBox>
    <svelte:fragment slot="buttonSet">
        {#if editMode}
            <ConfirmationButton
                legend="¿Está seguro de que desea confirmar el cambio de costo?"
                disabled={!valid || isSubmitting || !editHasChanges}
                label="Confirmar cambio de costo"
                on:click={updateOffer}
            />
        {:else}
            <ConfirmationButton
                legend="¿Está seguro de que desea enviar la oferta?"
                disabled={!valid || isSubmitting}
                label="Enviar oferta"
                on:click={addOffer}
            />
        {/if}
    </svelte:fragment>
</ModalX>

<style>
    :global(.v-thumb,.v-track) {
        z-index: 999999;
    }
</style>